import { render, staticRenderFns } from "./unit-live.vue?vue&type=template&id=364647d3&"
import script from "./unit-live.vue?vue&type=script&lang=js&"
export * from "./unit-live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports